"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blobToDataURL = blobToDataURL;
function blobToDataURL(blob) {
    const a = new FileReader();
    return new Promise((resolve, reject) => {
        a.onload = e => {
            if (e.target) {
                resolve(e.target.result);
            }
            else {
                reject(new Error('unknown result reading blob from canvas'));
            }
        };
        a.readAsDataURL(blob);
    });
}
